import { CustomerMarginConfiguration } from '@src/containers/Dealer/CustomerMarginConfiguration';
import type { CustomerMarginConfigurationPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerMarginConfigurationPanel({
  api,
  params,
}: LayoutPanelProps<CustomerMarginConfigurationPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-margin-configuration-panel"
    >
      <CustomerMarginConfiguration />
    </EntityAdminPanelShell>
  );
}
